export const throttle = (mainFunction, delay = 10) => {
  let lastCall = 0;
  return (...args) => {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      mainFunction(...args);
    }
  };
};
